import { PaginatedRequest } from '../types/api';
import {
  CreateHoldingCompanyRequest,
  CreateHoldingCompanyResponse,
  FetchHoldingCompanyResponse,
  FetchHoldingCompaniesResponse,
  UpdateHoldingCompanyRequest,
  UpdateHoldingCompanyResponse,
} from '../types/holdingCompany';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class HoldingCompanyService extends ApiService {
  pathname = 'admin';

  fetchHoldingCompanies = async (data: PaginatedRequest) =>
    this.get<FetchHoldingCompaniesResponse>(`${this.pathname}/company?${toQueryParams(data)}`);

  fetchHoldingCompany = async (id: number) => this.get<FetchHoldingCompanyResponse>(`${this.pathname}/company/${id}`);

  deleteHoldingCompany = async (id: number) =>
    this.delete<FetchHoldingCompanyResponse>(`${this.pathname}/company/${id}`);

  createHoldingCompany = async (holdingCompany: CreateHoldingCompanyRequest) =>
    this.post<CreateHoldingCompanyResponse, CreateHoldingCompanyRequest>(`${this.pathname}/company`, holdingCompany);

  updateHoldingCompany = async ({ id, ...holdingCompany }: UpdateHoldingCompanyRequest) =>
    this.put<UpdateHoldingCompanyResponse, Omit<UpdateHoldingCompanyRequest, 'id'>>(
      `${this.pathname}/company/${id}`,
      holdingCompany,
    );
}

export const holdingCompanyService = new HoldingCompanyService();
